import React, {useState} from 'react'
import {Button, Input, message, Modal, Popconfirm, Select} from "antd";
import {addTenantRouting} from "../../../../../../services/api/apiCustomerHub";
import {Option} from "antd/es/mentions";
import parseToken from "../../../../../../helpers/parseToken";

function RoutingAddModal(props) {
    const {custId, listTelco, isOpen, toggleModal, fetchTenantRouting, tenantFullName} = props
    const [validate, setValidate] = useState({})
    const [loading, setLoading] = useState(false)
    const [itemNew, setItemNew] = useState({})
    const decodeToken = parseToken()

    const handleCancel = () => {
        toggleModal()
    }

    const handleChangeItemNew = (name, value) => {
        setItemNew({
            ...itemNew,
            [name]: name === 'priority' ? parseInt(value) : value
        })
    }

    const mapTelcoCode = (code) => {
        const itemTelco = listTelco.find(item => item.code === code)
        if (itemTelco !== undefined) return itemTelco.name
        return ''
    }

    const _validateData = () => {
        let validateForm = {}
        if (itemNew?.callerPrefix === undefined) {
            Object.assign(validateForm, {callerPrefix: 'Chủ gọi là bắt buộc'})
        }
        if (itemNew?.calledPrefix === undefined) {
            Object.assign(validateForm, {calledPrefix: 'Bị gọi là bắt buộc'})
        }
        if (itemNew?.priority === undefined) {
            Object.assign(validateForm, {priority: 'Ưu tiên là bắt buộc'})
        }

        setValidate(validateForm)

        return validateForm
    }

    const _addTenantRouting = async () => {
        try {
            setLoading(true)
            const validateCheck = _validateData()
            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)
                message.error("Dữ liệu không hợp lệ")
                return false
            }
            const payload = {
                ...itemNew,
                ruleName: `${mapTelcoCode(itemNew?.callerPrefix)} gọi ${mapTelcoCode(itemNew?.calledPrefix)}`,
                tenantId: custId,
                tenantName: tenantFullName
            }
            const response = await addTenantRouting(decodeToken.sub, payload)
            setLoading(false)
            const {success, error_message} = response
            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }
            message.success('Thêm mới thành công!')
            setItemNew({})
            toggleModal()
            fetchTenantRouting()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    return (
        <Modal
            title="Thêm mới Định tuyến"
            className={`ModalCustom2`}
            style={{top: 20}}
            maskClosable={false}
            open={isOpen}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Button key="submit" type="primary" onClick={_addTenantRouting} loading={loading}>
                        Save
                    </Button>
                </div>
            ]}
        >
            <div className="FormEdit">
                <div className="row">
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Chủ gọi
                            <span className="Required">*</span>
                        </label>
                        <Select onChange={(value) => handleChangeItemNew('callerPrefix', value)} placeholder="Chọn"
                                style={{width: '100%', minWidth: '150px'}}>
                            {
                                listTelco.map(item => {
                                    return <Option value={item.code} key={item.code}>{item.name}</Option>
                                })
                            }
                        </Select>
                        {
                            validate?.callerPrefix &&
                            <span className="Error text-danger mt-1">{validate?.callerPrefix}</span>
                        }
                    </div>
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Bị gọi
                            <span className="Required">*</span>
                        </label>
                        <Select onChange={(value) => handleChangeItemNew('calledPrefix', value)} placeholder="Chọn"
                                style={{width: '100%', minWidth: '150px'}}>
                            {
                                listTelco.map(item => {
                                    return <Option value={item.code} key={item.code}>{item.name}</Option>
                                })
                            }
                        </Select>
                        {
                            validate?.calledPrefix &&
                            <span className="Error text-danger mt-1">{validate?.calledPrefix}</span>
                        }
                    </div>
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Ưu tiên
                            <span className="Required">*</span>
                        </label>
                        <Input onChange={(e) => handleChangeItemNew('priority', e.target.value)} type="number"/>
                        {
                            validate?.priority && <span className="Error text-danger mt-1">{validate?.priority}</span>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default RoutingAddModal
